import React, { useState} from "react";
import Navbar from "react-bootstrap/Navbar";
import UserWayAccessibilityMenu from "../components/UserWayAccessibilityMenu";
import "../App.css";
export default function Navheader(props) {
    const [navbar, setNavbar] = useState(false);

  const changebackground = () => {
    if(window.scrollY >= 10){
      setNavbar(true);
    }else{
      setNavbar(false);
    }
  };

  window.addEventListener('scroll', changebackground);
  return (
    <>
        <Navbar
          collapseOnSelect
          expand="lg"
          fixed="top"
          bg="dark"
          variant="dark"
          className={navbar ? 'navbar active' : 'navbar' }
        >
          <Navbar.Brand>
            <a href="https://www.swmc.com/" target="_blank" rel="noopener noreferrer">
              <img
                src="https://resources.swmc.com/swmc-images/Homepage/New/SunWest41YearsofTrust-Blue.png"
                className=" img-fluid w-50 main_logo"
                alt="Sun West Mortgage Logo"
              />
            </a>
          </Navbar.Brand>
          <UserWayAccessibilityMenu color="black" width={40} height={40} />
        </Navbar>
    </>
  );
}
